<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Revista
  </app-header-dialog>

  <div *ngIf="entityForm">

    <div class="content">

      <div style="margin-top: 10px;">
        <input type="file" #fileImage (change)="onFileSelected($event)" accept="image/*, application/pdf"
          style="display:none;">
        <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
          style='background-color: whitesmoke;'>
          <mat-icon class='icon-add'>image_search</mat-icon>
          Selecionar imagem da capa
        </a>
        <span style="margin: 0 20px 0 40px;" *ngIf="selectedFileName">{{selectedFileName}}</span>
      </div>

      <div style="display: flex; justify-content: center; width: 100%; margin: 10px;">
        <img [src]="storedImage" style="width: 300px;" *ngIf="storedImage">
      </div>

      <mat-form-field appearance="outline" style="margin-top: 10px;">
        <mat-label>Categoria</mat-label>
        <mat-select [errorStateMatcher]="matcher" [formControl]="entityForm.controls.type">
          <mat-option *ngFor="let type of types" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="entityForm.controls.type.hasError('required')">
          Selecione uma categoria
        </mat-error>
      </mat-form-field>

      <mat-form-field style='width: 620px;' appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field style='width: 620px;' appearance="outline">
        <mat-label>Link</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.link"
          autocomplete="off">
      </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button
        (click)="matDialogRef.close(['update', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>